export const focusSettingsToggler = () => {
  console.trace('focusSettingsToggler', document.activeElement);
  const activeEl = document.activeElement as HTMLElement | null;
  const togglerEl = document.getElementById('SettingsPanel-Toggler');
  if (activeEl === null || activeEl === togglerEl) return;
  activeEl.blur();
  togglerEl?.focus();
};
